export enum IccCaptureQueueCursorType {
  mostRecentlyCreated = 'most_recently_created',
  leastRecentlyCreated = 'least_recently_created',
}
